export default __webpack_public_path__ + "static/media/header_error.a244fa6d.svg";